import React, { useEffect, useState } from 'react';
import './App.css';
import M from 'materialize-css';

function App() {
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [projectsIndex, setProjectsIndex] = useState(0);
  const [blogsIndex, setBlogsIndex] = useState(0);
  const [isCarouselPaused, setIsCarouselPaused] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const projects = [
    {
      icon: 'tablet_mac',
      title: 'Post-Opoid Behavior Tracking App',
      description: 'Through the Stanford School of Medicine and CS342 Course at Stanford, I was part of a team that developed a post-opioid tracking mobile app that analyzed physiological and activity data. I primarily worked with HealthKit and ResearchKit from the Apple Developers Toolkit.'
    },
    {
      icon: 'local_hospital',
      title: 'Clinical Gaps Due to Legacy EHRs',
      description: 'Independent research through the Stanford Human Computer Interaction Department wherein I identified major gaps in clinical workflow due to legacy electronic-health records software. Interviewed major stakeholders at Stanford, VA & Community Hospitals.'
    },
    {
      icon: 'show_chart',
      title: 'Financial Analytics KPI Dashboard',
      description: 'Engineered a financial analytics dashboard that represented first and second-order financial metrics in real-time. Dealt with disparate data sources ranging from legacy software like Bloomberg Terminals to enterprise softwares like HubSpot&Periscope. Powered KPIs in real-time.'
    },
    {
      icon: 'local_pharmacy',
      title: 'Clinical Trial Analytics',
      description: 'Understanding and lanscaping the role of international CRO(s) in the facilitation for clinical trials during Phase II and Phase III drug studies. I delved deeper into the economies of scale achieved, the data aggregated by CROs, and areas of improvement to shorten trial timelines and improve R&D efficiency by 10x. Unravelled engagement rates for trials in developing countries.'
    },
    {
      icon: 'device_hub',
      title: 'Petsafe',
      description: 'Developed a device that can quantify physiological distress with 90% accuracy. Analyzed heart-rate, pulse oximetry, perspiration, and respiratory rate for dogs to quantify physiological distress and alert authorities during medical emergency. The long-term goal is to serve as a remote-patient monitoring tool for humans during chronic disease.'
    },
    {
      icon: 'photo_album',
      title: 'Integrated Photo-App',
      description: "For Stanford's web-applications class (CS142), I developed a React-js based photo-app that enabled users to view profiles, add friends, customize their own profiles, add and update photos, and delete their accounts. I enhanced my skill-set with web development skills that enabled me to build a social networking website equipped with noSQL databases and server-side + browser-side support."
    }
  ];

  const nextProjects = () => {
    setProjectsIndex((prev) => {
      const maxIndex = Math.max(0, projects.length - 3);
      return prev + 3 > maxIndex ? 0 : prev + 3;
    });
  };

  const prevProjects = () => {
    setProjectsIndex((prev) => {
      const maxIndex = Math.max(0, projects.length - 3);
      return prev - 3 < 0 ? maxIndex : prev - 3;
    });
  };

  const blogs = [
    { title: 'Coming Soon', description: 'Articles and blog posts will be featured here.' },
    { title: 'Coming Soon', description: 'Articles and blog posts will be featured here.' },
    { title: 'Coming Soon', description: 'Articles and blog posts will be featured here.' },
    { title: 'Coming Soon', description: 'Articles and blog posts will be featured here.' },
    { title: 'Coming Soon', description: 'Articles and blog posts will be featured here.' },
    { title: 'Coming Soon', description: 'Articles and blog posts will be featured here.' }
  ];


  const nextBlogs = () => {
    setBlogsIndex((prev) => {
      const maxIndex = Math.max(0, blogs.length - 3);
      return prev + 3 > maxIndex ? 0 : prev + 3;
    });
  };

  const prevBlogs = () => {
    setBlogsIndex((prev) => {
      const maxIndex = Math.max(0, blogs.length - 3);
      return prev - 3 < 0 ? maxIndex : prev - 3;
    });
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    // Email address stored in JavaScript, not visible in HTML
    const recipientEmail = 'dsharma7@alumni.stanford.edu';
    
    const fullName = document.getElementById('fullName').value;
    const email = document.getElementById('email').value;
    const subject = document.getElementById('subject').value;
    const message = document.getElementById('message').value;
    
    const subjectLine = `Contact Form: ${subject} - ${fullName}`;
    const body = `Name: ${fullName}\nEmail: ${email}\nSubject: ${subject}\n\nMessage:\n${message}`;
    
    // Create mailto link
    const mailtoLink = `mailto:${recipientEmail}?subject=${encodeURIComponent(subjectLine)}&body=${encodeURIComponent(body)}`;
    
    // Open email client
    window.location.href = mailtoLink;
    
    // Reset form
    document.getElementById('fullName').value = '';
    document.getElementById('email').value = '';
    document.getElementById('subject').value = '';
    document.getElementById('message').value = '';
  };


  const carouselImages = [
    {
      image: '/img/NLP.jpeg',
      description: 'Lead Lean In Network San Francisco and build a thriving community for women'
    },
    {
      image: '/img/Global Shapers.jpeg',
      description: 'Working with a community of 20+ with the World Economic Forum Global Shapers Community of San Francisco'
    },
    {
      image: '/img/UnabridgedMD.png',
      description: 'Launched Flair Health backed by Y Combinator - first product line improving the lives of hundreds of patients in partnership with insurance companies and clinics, team of 8'
    },
    {
      image: '/img/Stanford_Grad.jpeg',
      description: 'Graduated from Stanford 2021, coursework in Computer Science with some Economics'
    },
    {
      image: '/img/EU.jpeg',
      description: 'Was selected as 8VC, Bessemer, Pear and KP Fellow Finalist at Stanford while interning at J&J Medtech, Meta, Neighborly'
    },
    {
      image: '/img/eu.jpg',
      description: "Invited speaker to the European Commission's Horizon 2020 Annual Research & Innovation Conference planning commission 2017."
    },
    {
      image: '/img/worldbank.jpg',
      description: 'Presented health tech innovation at the World Bank (2016) in partnership with the Indian government and Department of Science and Technology.'
    },
    {
      image: '/img/president.jpg',
      description: 'Won a national award from the President of India in 2015 for my innovation in health tech.'
    },
    {
      image: '/img/Device.jpg',
      description: 'Built & Patented a Remote Patient Monitoring Device in Partnership with governments and hospitals'
    },
    {
      image: '',
      description: ''
    },
    {
      image: '',
      description: ''
    },
  ];

  // Filter out empty items on mobile, show all items on desktop
  const filteredCarouselImages = isMobile 
    ? carouselImages.filter(item => item.image && item.image.trim() !== '')
    : carouselImages;

  const nextSlide = () => {
    setCarouselIndex((prev) => {
      const itemsPerView = isMobile ? 1 : 3;
      const maxIndex = Math.max(0, filteredCarouselImages.length - itemsPerView);
      return prev + itemsPerView > maxIndex ? 0 : prev + itemsPerView;
    });
  };

  const prevSlide = () => {
    setCarouselIndex((prev) => {
      const itemsPerView = isMobile ? 1 : 3;
      const maxIndex = Math.max(0, filteredCarouselImages.length - itemsPerView);
      return prev - itemsPerView < 0 ? maxIndex : prev - itemsPerView;
    });
  };

  // Auto-rotate carousel every 5 seconds
  useEffect(() => {
    if (isCarouselPaused) return;
    
    const interval = setInterval(() => {
      setCarouselIndex((prev) => {
        // On mobile, show one item at a time; on desktop, show 3
        const itemsPerView = isMobile ? 1 : 3;
        const maxIndex = Math.max(0, filteredCarouselImages.length - itemsPerView);
        return prev + itemsPerView > maxIndex ? 0 : prev + itemsPerView;
      });
    }, 5000); // Rotate every 5 seconds

    return () => clearInterval(interval);
  }, [isCarouselPaused, isMobile, filteredCarouselImages.length]);

  useEffect(() => {
    // Handle window resize for mobile detection
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Initialize Materialize components
    const sideNav = document.querySelector('.sidenav');
    if (sideNav) {
      const instance = M.Sidenav.init(sideNav, {
        edge: 'right',
        draggable: false,
        inDuration: 200, // Faster open animation (default is 250)
        outDuration: 150, // Faster close animation (default is 200)
        onOpenStart: () => {
          // Force centering when opening, positioned slightly below hamburger
          if (window.innerWidth <= 768) {
            sideNav.style.left = '50%';
            sideNav.style.right = 'auto';
            sideNav.style.top = 'calc(50% + 35px)';
            sideNav.style.transform = 'translateX(-50%) translateY(-50%)';
          }
        },
        onOpenEnd: () => {
          // Ensure centered after animation
          if (window.innerWidth <= 768) {
            sideNav.style.transform = 'translateX(-50%) translateY(-50%)';
          }
        },
        onCloseEnd: () => {
          // Reset transform when closed for next open
          if (window.innerWidth <= 768) {
            sideNav.style.transform = '';
          }
        }
      });
      
      // Close menu when clicking on menu links (with slight delay for smooth navigation)
      const menuLinks = sideNav.querySelectorAll('.mobile-menu-link');
      menuLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          // Allow default navigation but close menu quickly
          setTimeout(() => {
            if (instance.isOpen) {
              instance.close();
            }
          }, 50);
        });
      });
      
      // Store instance globally for easy access
      window.mobileNavInstance = instance;
      
      // Handle window resize
      const handleResize = () => {
        if (window.innerWidth <= 768 && instance.isOpen) {
          sideNav.style.left = '50%';
          sideNav.style.right = 'auto';
          sideNav.style.top = '50%';
          sideNav.style.transform = 'translateX(-50%) translateY(-50%)';
        }
      };
      
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
    

    // Initialize scrollspy
    const scrollSpy = document.querySelectorAll('.scrollspy');
    if (scrollSpy.length > 0) {
      M.ScrollSpy.init(scrollSpy, {});
    }

    // Initialize materialbox for images
    const materialbox = document.querySelectorAll('.materialboxed');
    if (materialbox.length > 0) {
      M.Materialbox.init(materialbox, {});
    }

    // Initialize input fields
    M.updateTextFields();

    // Ensure Font Awesome is loaded
    const checkFontAwesome = setInterval(() => {
      if (window.FontAwesome || document.querySelector('.fa-linkedin')) {
        clearInterval(checkFontAwesome);
      }
    }, 100);
    
    setTimeout(() => clearInterval(checkFontAwesome), 5000);
  }, []);

  return (
    <div className="App" id="top">
      {/* Navbar */}
      <div className="navbar-fixed">
        <nav className="navbar-custom">
          <div className="nav-container">
            <a href="#top" className="brand-name">Diva Avaya Sharma</a>
            <a href="#!" data-target="mobile-nav" className="sidenav-trigger mobile-menu">
              <i className="material-icons">menu</i>
            </a>
            <div className="nav-links-container">
              <ul className="nav-links hide-on-med-and-down">
                <li><a href="#about">About</a></li>
                <li><a href="#photos">Updates</a></li>
                <li><a href="#speaking">Speaking</a></li>
                <li><a href="#blogs">Blogs & Content</a></li>
                <li><a href="#music">Music</a></li>
                <li><a href="#projects">Projects</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
            <div className="social-icons-container">
              <a href="https://www.linkedin.com/in/diva-sharma/" target="_blank" rel="noopener noreferrer" className="social-icon">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="https://x.com/adivawhocodes/" target="_blank" rel="noopener noreferrer" className="social-icon">
                <span style={{fontWeight: 'bold', fontSize: '24px', color: '#000000', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%'}}>X</span>
              </a>
              <a href="https://www.instagram.com/arealdiva/" target="_blank" rel="noopener noreferrer" className="social-icon">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://medium.com/@diva.sharma" target="_blank" rel="noopener noreferrer" className="social-icon">
                <i className="fab fa-medium"></i>
              </a>
            </div>
          </div>
        </nav>
      </div>

      {/* Mobile Nav */}
      <ul className="sidenav mobile-dropdown" id="mobile-nav">
        <li><a href="#about" className="mobile-menu-link">About</a></li>
        <li><a href="#photos" className="mobile-menu-link">Updates</a></li>
        <li><a href="#speaking" className="mobile-menu-link">Speaking</a></li>
        <li><a href="#blogs" className="mobile-menu-link">Blogs & Content</a></li>
        <li><a href="#music" className="mobile-menu-link">Music</a></li>
        <li><a href="#projects" className="mobile-menu-link">Projects</a></li>
        <li><a href="#contact" className="mobile-menu-link">Contact</a></li>
        <li style={{marginTop: '2rem', padding: '0 1rem'}}>
          <div style={{display: 'flex', flexDirection: 'column', gap: '0.75rem'}}>
            <a href="https://www.linkedin.com/in/diva-sharma/" target="_blank" rel="noopener noreferrer" className="mobile-menu-button-outline">
              LinkedIn
            </a>
            <a href="https://x.com/adivawhocodes/" target="_blank" rel="noopener noreferrer" className="mobile-menu-button-filled">
              X
            </a>
            <a href="https://www.instagram.com/arealdiva/" target="_blank" rel="noopener noreferrer" className="mobile-menu-button-outline">
              Instagram
            </a>
            <a href="https://medium.com/@diva.sharma" target="_blank" rel="noopener noreferrer" className="mobile-menu-button-filled">
              Medium
            </a>
          </div>
        </li>
      </ul>

      {/* Photo Carousel */}
      <div 
        className="photo-carousel-container"
        onMouseEnter={() => setIsCarouselPaused(true)}
        onMouseLeave={() => setIsCarouselPaused(false)}
      >
        <button className="carousel-arrow carousel-arrow-left" onClick={prevSlide}>
          <i className="material-icons">chevron_left</i>
        </button>
        <div className="photo-carousel">
          <div className="carousel-track" style={{transform: `translateX(-${carouselIndex * (isMobile ? 100 : 33.333)}%)`}}>
            {filteredCarouselImages.map((item, index) => {
              const bannerColors = ['#00a8ff', '#ffffff'];
              const bannerColor = bannerColors[index % bannerColors.length];
              const textColor = bannerColor === '#ffffff' ? '#000000' : '#ffffff';
              
              // Show date for specific images, otherwise show TED
              let bannerText = 'TED';
              if (item.image === '/img/Device.jpg') {
                bannerText = '2014';
              } else if (item.image === '/img/president.jpg') {
                bannerText = '2015';
              } else if (item.image === '/img/tedx.jpg') {
                bannerText = '2016';
              } else if (item.image === '/img/worldbank.jpg') {
                bannerText = '2016';
              } else if (item.image === '/img/eu.jpg') {
                bannerText = '2017';
              } else if (item.image === '/img/Stanford_Grad.jpeg') {
                bannerText = '2021';
              } else if (item.image === '/img/NLP.jpeg') {
                bannerText = '2025';
              } else if (item.image === '/img/Global Shapers.jpeg') {
                bannerText = '2025';
              } else if (item.image === '/img/UnabridgedMD.png') {
                bannerText = '2023';
              } else if (item.image === '/img/EU.jpeg') {
                bannerText = '2018';
              }
              
              return (
                <div key={index} className="carousel-photo">
                  {item.image ? (
                    <>
                      <div style={{position: 'relative'}}>
                        {item.image === '/img/eu.jpg' ? (
                          <a href="https://www.linkedin.com/in/diva-sharma/overlay/1733951292070/single-media-viewer/?profileId=ACoAABp-tjEBDokRwzKqfLf7eX_le4HBw12mAlc" target="_blank" rel="noopener noreferrer" style={{display: 'block'}}>
                            <img src={item.image} alt={`Photo ${index + 1}`} />
                          </a>
                        ) : (
                          <img src={item.image} alt={`Photo ${index + 1}`} />
                        )}
                        <div className="carousel-brand-logo" style={{backgroundColor: bannerColor, color: textColor}}>{bannerText}</div>
                      </div>
                      <div className="carousel-caption">
                        <p>{item.description}</p>
                      </div>
                    </>
                  ) : (
                    <div style={{backgroundColor: '#1a1a1a', minHeight: '300px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <div style={{color: '#666', fontSize: '0.9rem'}}>Empty slot</div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <button className="carousel-arrow carousel-arrow-right" onClick={nextSlide}>
          <i className="material-icons">chevron_right</i>
        </button>
      </div>

      {/* About Section */}
      <section id="about" className="section section-search white-text center scrollspy" style={{backgroundColor: '#4eaad7'}}>
        <div className="container">
          <h2 className="section-title" style={{color: 'white', textAlign: 'center', marginBottom: '1rem', marginTop: '0', paddingTop: '1rem'}}>About</h2>
          <div className="row" style={{display: 'flex', alignItems: 'stretch'}}>
            <div className="col s12 m6" style={{textAlign: 'left', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
              <span style={{color: 'white', fontSize: '0.85rem', lineHeight: '1.8'}}>
                Diva Avaya Sharma is a technology entrepreneur. She's the founder of <a href="https://cognitiolabs.com" target="_blank" rel="noopener noreferrer" style={{color: '#000000', textDecoration: 'underline'}}>Cognitio Labs</a>, backed by <a href="https://www.ycombinator.com" target="_blank" rel="noopener noreferrer" style={{color: '#000000', textDecoration: 'underline'}}>Y Combinator</a> & leading technology investors to tackle 100B+ problems in payments, compliance, and contracting.
                <br /><br />
                <strong>Venture Capital:</strong> Previously was selected as a fellow at venture firms <a href="https://8vc.com" target="_blank" rel="noopener noreferrer" style={{color: '#000000', textDecoration: 'underline'}}>8VC</a>, <a href="https://www.bvp.com" target="_blank" rel="noopener noreferrer" style={{color: '#000000', textDecoration: 'underline'}}>Bessemer Venture Partners</a>, and <a href="https://www.pear.vc" target="_blank" rel="noopener noreferrer" style={{color: '#000000', textDecoration: 'underline'}}>Pear Ventures</a>, collaborating with portfolio companies.
                <br /><br />
                <strong>Corporate, Government & Economic Research:</strong> Worked with Fortune 500 companies (<a href="https://www.jnj.com" target="_blank" rel="noopener noreferrer" style={{color: '#000000', textDecoration: 'underline'}}>J&J Medtech</a>, <a href="https://www.meta.com" target="_blank" rel="noopener noreferrer" style={{color: '#000000', textDecoration: 'underline'}}>Meta</a>), governments, and economic innovation labs on initiatives at the intersection of technology, policy, and growth.
                <br /><br />
                <strong>Technology for Global Development:</strong> Patented a rural health monitoring device recognized by the <a href="https://www.india.gov.in" target="_blank" rel="noopener noreferrer" style={{color: '#000000', textDecoration: 'underline'}}>Indian Government</a>, <a href="https://www.worldbank.org" target="_blank" rel="noopener noreferrer" style={{color: '#000000', textDecoration: 'underline'}}>World Bank</a>, and <a href="/docs/EU_speakers_profiles.pdf" target="_blank" rel="noopener noreferrer" style={{color: '#000000', textDecoration: 'underline'}}>European Commission</a>, with work recognized by <a href="https://www.forbes.com/profile/diva-sharma" target="_blank" rel="noopener noreferrer" style={{color: '#000000', textDecoration: 'underline'}}>Forbes 30 Under 30</a> and the President of India. She was recently selected for the <strong>World Economic Forum's Future 26 Cohort</strong>—an initiative that brings together a highly selective group of emerging global leaders shaping the future of technology, policy, and society.
                <br /><br />
                <strong>Communities:</strong> Advances local innovation through the <a href="https://www.globalshapers.org" target="_blank" rel="noopener noreferrer" style={{color: '#000000', textDecoration: 'underline'}}>World Economic Forum's Global Shapers San Francisco Hub</a> and <a href="https://leanin.org" target="_blank" rel="noopener noreferrer" style={{color: '#000000', textDecoration: 'underline'}}>San Francisco's Lean In Network</a>, and partners with the <a href="https://kingcenter.stanford.edu" target="_blank" rel="noopener noreferrer" style={{color: '#000000', textDecoration: 'underline'}}>Stanford King Center</a> on Global Development to create a community to highlight AI's role in achieving sustainable development goals.
              </span>
            </div>
            <div className="col s12 m6" style={{display: 'flex', justifyContent: 'center', alignItems: 'stretch', paddingLeft: '2rem'}}>
              <img src="/img/YC_diva 2.jpg" className="about-main-image responsive-img" alt="Diva Avaya Sharma" />
            </div>
          </div>
          <div className="row" style={{marginTop: '1.12rem', textAlign: 'center'}}>
            <div className="col s12">
              <a href="#contact" className="contact-me-button">
                Contact Me
                <i className="material-icons right">arrow_forward</i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Affiliations Section */}
      <section id="affiliations" className="affiliations-section scrollspy">
        <div className="container">
          <h2 className="section-title" style={{color: 'white'}}>Affiliations</h2>
          <div className="affiliations-slider">
            <div className="affiliations-track">
              <a href="https://www.stanford.edu" target="_blank" rel="noopener noreferrer" className="affiliation-logo">
                <img src="/img/stanford.jpeg" alt="Stanford" />
              </a>
              <a href="https://stanford-entrepreneurs.com/diva-sharma/" target="_blank" rel="noopener noreferrer" className="affiliation-logo">
                <img src="/img/Stanford Alumni Entrepreneurs Logo.png" alt="Stanford Alumni Entrepreneurs" />
              </a>
              <a href="https://www.india.gov.in" target="_blank" rel="noopener noreferrer" className="affiliation-logo">
                <div className="affiliation-text-logo" style={{backgroundColor: '#FF9933', color: 'white', padding: '0.5rem 1rem', borderRadius: '4px', fontWeight: '600', fontSize: '0.75rem', textAlign: 'center', lineHeight: '1.2'}}>Government<br />of India</div>
              </a>
              <a href="https://www.ycombinator.com" target="_blank" rel="noopener noreferrer" className="affiliation-logo">
                <div className="affiliation-text-logo" style={{backgroundColor: '#FF6A00', color: 'white', padding: '0.5rem 1rem', borderRadius: '4px', fontWeight: '600', fontSize: '0.85rem'}}>Y Combinator</div>
              </a>
              <a href="https://www.globalshapers.org" target="_blank" rel="noopener noreferrer" className="affiliation-logo">
                <img src="/img/WEF.png" alt="World Economic Forum" />
              </a>
              <a href="https://leanin.org" target="_blank" rel="noopener noreferrer" className="affiliation-logo">
                <img src="/img/Lean In Network.png" alt="Lean In Network" className="lean-in-logo" />
              </a>
              <a href="https://www.forbes.com/30-under-30" target="_blank" rel="noopener noreferrer" className="affiliation-logo">
                <div className="affiliation-text-logo" style={{backgroundColor: '#FFCC00', color: '#000000', padding: '0.5rem 1rem', borderRadius: '4px', fontWeight: '700', fontSize: '0.8rem', textAlign: 'center', lineHeight: '1.2'}}>Forbes<br />30 Under 30</div>
              </a>
              {/* Duplicate for seamless loop */}
              <a href="https://www.stanford.edu" target="_blank" rel="noopener noreferrer" className="affiliation-logo">
                <img src="/img/stanford.jpeg" alt="Stanford" />
              </a>
              <a href="https://stanford-entrepreneurs.com/diva-sharma/" target="_blank" rel="noopener noreferrer" className="affiliation-logo">
                <img src="/img/Stanford Alumni Entrepreneurs Logo.png" alt="Stanford Alumni Entrepreneurs" />
              </a>
              <a href="https://www.india.gov.in" target="_blank" rel="noopener noreferrer" className="affiliation-logo">
                <div className="affiliation-text-logo" style={{backgroundColor: '#FF9933', color: 'white', padding: '0.5rem 1rem', borderRadius: '4px', fontWeight: '600', fontSize: '0.75rem', textAlign: 'center', lineHeight: '1.2'}}>Government<br />of India</div>
              </a>
              <a href="https://www.ycombinator.com" target="_blank" rel="noopener noreferrer" className="affiliation-logo">
                <div className="affiliation-text-logo" style={{backgroundColor: '#FF6A00', color: 'white', padding: '0.5rem 1rem', borderRadius: '4px', fontWeight: '600', fontSize: '0.85rem'}}>Y Combinator</div>
              </a>
              <a href="https://www.globalshapers.org" target="_blank" rel="noopener noreferrer" className="affiliation-logo">
                <img src="/img/WEF.png" alt="World Economic Forum" />
              </a>
              <a href="https://leanin.org" target="_blank" rel="noopener noreferrer" className="affiliation-logo">
                <img src="/img/Lean In Network.png" alt="Lean In Network" className="lean-in-logo" />
              </a>
              <a href="https://www.forbes.com/30-under-30" target="_blank" rel="noopener noreferrer" className="affiliation-logo">
                <div className="affiliation-text-logo" style={{backgroundColor: '#FFCC00', color: '#000000', padding: '0.5rem 1rem', borderRadius: '4px', fontWeight: '700', fontSize: '0.8rem', textAlign: 'center', lineHeight: '1.2'}}>Forbes<br />30 Under 30</div>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Photo Gallery Section */}
      <section id="photos" className="section section-gallery scrollspy" style={{backgroundColor: '#1a1a1a', paddingTop: '4rem', paddingBottom: '4rem'}}>
        <div className="container">
          <h2 className="section-title" style={{color: 'white'}}>Updates</h2>
          <div className="row">
            <div className="col s12 m3">
              <a href="https://www.ycombinator.com" target="_blank" rel="noopener noreferrer" style={{display: 'block', textDecoration: 'none'}}>
                <img className="materialboxed responsive-img" src="/img/ycombinator-tile.svg" alt="Y Combinator" />
              </a>
            </div>
            <div className="col s12 m3">
              <a href="https://stanford-entrepreneurs.com/diva-sharma/" target="_blank" rel="noopener noreferrer" style={{display: 'block', textDecoration: 'none'}}>
                <img className="materialboxed responsive-img" src="/img/Stanford Alumni Entrepreneurs Logo.png" alt="Stanford Alumni Entrepreneurs" />
              </a>
            </div>
            <div className="col s12 m3">
              <a href="https://www.8vc.com/fellows/diva-sharma" target="_blank" rel="noopener noreferrer" style={{display: 'block', textDecoration: 'none'}}>
                <img className="materialboxed responsive-img" src="/img/8VC-Logo.jpg" alt="8VC" />
              </a>
            </div>
            <div className="col s12 m3">
              <a href="https://www.bvp.com/news/bessemers-inaugural-2020-fellowship-class" target="_blank" rel="noopener noreferrer" style={{display: 'block', textDecoration: 'none'}}>
                <img className="materialboxed responsive-img" src="/img/Bessemer_Logo.jpg" alt="Bessemer" />
              </a>
            </div>
            <div className="col s12 m3">
              <a href="https://stanforddaily.com/2018/05/15/qa-freshman-diva-sharma-on-innovation-in-health-care/" target="_blank" rel="noopener noreferrer" style={{display: 'block', textDecoration: 'none'}}>
                <img className="materialboxed responsive-img" src="/img/Stanford Daily.png" alt="Stanford Daily" />
              </a>
            </div>
            <div className="col s12 m3">
              <a href="https://cio.economictimes.indiatimes.com/news/business-analytics/women-led-businesses-are-still-underfunded/98478196" target="_blank" rel="noopener noreferrer" style={{display: 'block', textDecoration: 'none'}}>
                <img className="materialboxed responsive-img" src="/img/The_Economic_Times_logo.png" alt="The Economic Times" />
              </a>
            </div>
            <div className="col s12 m3">
              <a href="https://www.forbes.com/profile/diva-sharma/" target="_blank" rel="noopener noreferrer" style={{display: 'block', textDecoration: 'none'}}>
                <img className="materialboxed responsive-img" src="/img/forbes.jpeg" alt="Forbes" />
              </a>
            </div>
            <div className="col s12 m3">
              <a href="/docs/EU_speakers_profiles.pdf" target="_blank" rel="noopener noreferrer" style={{display: 'block', textDecoration: 'none'}}>
                <img className="materialboxed responsive-img" src="/img/European Union.jpeg" alt="European Union" />
              </a>
            </div>
            <div className="col s12 m3">
              <a href="https://www.educationtimes.com/article/school-guide/69481813/presidents-medal-for-innovation" target="_blank" rel="noopener noreferrer" style={{display: 'block', textDecoration: 'none'}}>
                <img className="materialboxed responsive-img" src="/img/Times Of India.png" alt="Times Of India" />
              </a>
            </div>
            <div className="col s12 m3">
              <a href="https://www.educationtimes.com/article/school-guide/69479602/youth-talks" target="_blank" rel="noopener noreferrer" style={{display: 'block', textDecoration: 'none'}}>
                <img className="materialboxed responsive-img" src="/img/World bank.jpg" alt="World Bank" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Speaking Section */}
      <section id="speaking" className="speaking-video-section scrollspy">
        <div className="container">
          <h2 className="speaking-video-title">Speaking</h2>
          
          <div className="row" style={{marginTop: '3rem'}}>
            {/* TEDx Talk Video Card */}
            <div className="col s12 m6">
              <div className="video-card">
                <div className="video-card-header">
                  <div className="video-actions">
                    <button className="video-action-btn">
                      <i className="material-icons">access_time</i>
                    </button>
                    <button className="video-action-btn">
                      <i className="material-icons">share</i>
                    </button>
                  </div>
                  <div className="video-brand-logo ted-logo">TED</div>
                </div>
                <div className="video-thumbnail-container">
                  <img src="/img/tedx.jpg" alt="TEDx Talk" className="video-thumbnail" />
                  <div className="play-button">
                    <i className="material-icons">play_circle_filled</i>
                  </div>
                  <div className="video-overlay-text">
                    <span>80,000+ views • Selected by Girl Empowerment x Tedx talks</span>
                    <i className="material-icons">chevron_right</i>
                  </div>
                </div>
                <div className="video-card-content">
                  <h3 className="video-title">Girls need to lean in too! | Diva Sharma | TEDxWalledCity</h3>
                  <a href="https://www.youtube.com/watch?v=bJxLEFnDR50" target="_blank" rel="noopener noreferrer" className="youtube-watch-btn">
                    <span>Watch on</span>
                    <i className="fab fa-youtube"></i>
                    <span>YouTube</span>
                  </a>
                </div>
              </div>
            </div>

            {/* EU Talk Video Card */}
            <div className="col s12 m6">
              <div className="video-card">
                <div className="video-card-header">
                  <div className="video-actions">
                    <button className="video-action-btn">
                      <i className="material-icons">access_time</i>
                    </button>
                    <button className="video-action-btn">
                      <i className="material-icons">share</i>
                    </button>
                  </div>
                  <div className="video-brand-logo eu-logo">EU</div>
                </div>
                <div className="video-thumbnail-container">
                  <img src="/img/eu.jpg" alt="European Union Talk" className="video-thumbnail" />
                  <div className="play-button">
                    <i className="material-icons">play_circle_filled</i>
                  </div>
                </div>
                <div className="video-card-content">
                  <h3 className="video-title">European Union Horizon 2020 Conference Presentation</h3>
                  <a href="/docs/EU_speakers_profiles.pdf" target="_blank" rel="noopener noreferrer" className="youtube-watch-btn">
                    <span>View Document</span>
                    <i className="material-icons" style={{fontSize: '1.2rem'}}>description</i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row" style={{marginTop: '2rem'}}>
            {/* Girl Empowerment Video Card */}
            <div className="col s12 m6">
              <div className="video-card">
                <div className="video-card-header">
                  <div className="video-actions">
                    <button className="video-action-btn">
                      <i className="material-icons">access_time</i>
                    </button>
                    <button className="video-action-btn">
                      <i className="material-icons">share</i>
                    </button>
                  </div>
                  <div className="video-brand-logo ted-logo" style={{backgroundColor: '#ff69b4'}}>Girl Empowerment</div>
                </div>
                <div className="video-thumbnail-container">
                  <img src="/img/tedx.jpg" alt="Girl Empowerment Talk" className="video-thumbnail" />
                  <div className="play-button">
                    <i className="material-icons">play_circle_filled</i>
                  </div>
                  <div className="video-overlay-text">
                    <span>289k views • Selected by the Gates Foundation list</span>
                    <i className="material-icons">chevron_right</i>
                  </div>
                </div>
                <div className="video-card-content">
                  <h3 className="video-title">Girl Empowerment Talk</h3>
                  <a href="https://www.youtube.com/watch?v=2WHQrG5IDC8" target="_blank" rel="noopener noreferrer" className="youtube-watch-btn">
                    <span>Watch on</span>
                    <i className="fab fa-youtube"></i>
                    <span>YouTube</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Blogs & Writing Section */}
      <section id="blogs" className="speaking-video-section scrollspy">
        <div className="container">
          <h2 className="speaking-video-title">Blogs & Writing</h2>
          
          <div className="row" style={{marginTop: '3rem'}}>
            {/* Medium Blog Post Card */}
            <div className="col s12 m6">
              <div className="video-card">
                <div className="video-card-header">
                  <div className="video-actions">
                    <button className="video-action-btn">
                      <i className="material-icons">access_time</i>
                    </button>
                    <button className="video-action-btn">
                      <i className="material-icons">share</i>
                    </button>
                  </div>
                  <div className="video-brand-logo ted-logo" style={{backgroundColor: '#00ab6c'}}>Medium</div>
                </div>
                <div className="video-thumbnail-container">
                  <img src="/img/licensinglaws_article.png?v=3" alt="Medium Article - The Licensing Laws You Didn't Know Were Raising Your Costs" className="video-thumbnail" />
                  <div className="play-button">
                    <i className="material-icons">description</i>
                  </div>
                </div>
                <div className="video-card-content">
                  <h3 className="video-title">The Licensing Laws You Didn't Know Were Raising Your Costs</h3>
                  <a href="https://medium.com/@diva.sharma/the-licensing-laws-you-didnt-know-were-raising-your-costs-5766725ead45" target="_blank" rel="noopener noreferrer" className="youtube-watch-btn">
                    <span>Read on</span>
                    <i className="fab fa-medium"></i>
                    <span>Medium</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Music Section */}
      <section id="music" className="speaking-video-section scrollspy">
        <div className="container">
          <h2 className="speaking-video-title">Music</h2>
          
          <div className="row" style={{marginTop: '3rem'}}>
            {/* Aurora Hunters Song Card */}
            <div className="col s12 m6">
              <div className="video-card">
                <div className="video-card-header">
                  <div className="video-actions">
                    <button className="video-action-btn">
                      <i className="material-icons">access_time</i>
                    </button>
                    <button className="video-action-btn">
                      <i className="material-icons">share</i>
                    </button>
                  </div>
                  <div className="video-brand-logo ted-logo" style={{backgroundColor: '#c4122e'}}>iHeart</div>
                </div>
                <div className="video-thumbnail-container">
                  <img src="/img/arealdiva.png" alt="Aurora Hunters" className="video-thumbnail" />
                  <div className="play-button">
                    <i className="material-icons">play_circle_filled</i>
                  </div>
                </div>
                <div className="video-card-content">
                  <h3 className="video-title">Aurora Hunters</h3>
                  <a href="https://www.iheart.com/artist/arealdiva-46550165/" target="_blank" rel="noopener noreferrer" className="youtube-watch-btn">
                    <span>Listen on</span>
                    <i className="fas fa-music"></i>
                    <span>iHeart Radio</span>
                  </a>
                </div>
              </div>
            </div>

            {/* Radio One International Video Card */}
            <div className="col s12 m6">
              <div className="video-card">
                <div className="video-card-header">
                  <div className="video-actions">
                    <button className="video-action-btn">
                      <i className="material-icons">access_time</i>
                    </button>
                    <button className="video-action-btn">
                      <i className="material-icons">share</i>
                    </button>
                  </div>
                  <div className="video-brand-logo ted-logo" style={{backgroundColor: '#ff0000'}}>Radio One International</div>
                </div>
                <div className="video-thumbnail-container">
                  <img src="/img/radiooneinternational.png" alt="Radio One International" className="video-thumbnail" />
                  <div className="play-button">
                    <i className="material-icons">play_circle_filled</i>
                  </div>
                </div>
                <div className="video-card-content">
                  <h3 className="video-title">Radio One International</h3>
                  <a href="https://www.youtube.com/watch?v=8P6fCG8q5m4&t=425s" target="_blank" rel="noopener noreferrer" className="youtube-watch-btn">
                    <span>Watch on</span>
                    <i className="fab fa-youtube"></i>
                    <span>YouTube</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Updates/Social Media Section */}
      <section id="updates" className="section section-follow black darken-2 white-text center" style={{display: 'none'}}>
        <div className="container">
          <div className="row">
            <div className="col s12">
              <h2 className="section-title" style={{color: 'white'}}>Follow Me</h2>
              <p>Follow me on Social Media</p>
              <a href="https://www.instagram.com/arealdiva/" target="_blank" rel="noopener noreferrer" className="white-text">
                <i className="fab fa-instagram fa-4x"></i>
              </a>
              <a href="https://x.com/adivawhocodes/" target="_blank" rel="noopener noreferrer" className="white-text">
                <span style={{fontWeight: 'bold', fontSize: '4rem'}}>X</span>
              </a>
              <a href="https://www.linkedin.com/in/diva-sharma/" target="_blank" rel="noopener noreferrer" className="white-text">
                <i className="fab fa-linkedin fa-4x"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section className="section section-icons center" id="projects" style={{backgroundColor: '#1a1a1a', paddingTop: '4rem', paddingBottom: '4rem'}}>
        <div className="container">
          <h2 className="section-title" style={{color: 'white'}}>Projects</h2>
          <div className="projects-carousel-container">
            <button className="projects-arrow projects-arrow-left" onClick={prevProjects}>
              <i className="material-icons">chevron_left</i>
            </button>
            <div className="projects-carousel">
              <div className="projects-track" style={{transform: `translateX(-${projectsIndex * 33.333}%)`}}>
                {projects.map((project, index) => (
                  <div key={index} className="project-card">
                  <div className="card-panel project-card-panel">
                    <i className={`material-icons large white-text`}>{project.icon}</i>
                    <h4>{project.title}</h4>
                    <p style={{textAlign: 'left', color: 'white'}}>{project.description}</p>
                  </div>
                  </div>
                ))}
              </div>
            </div>
            <button className="projects-arrow projects-arrow-right" onClick={nextProjects}>
              <i className="material-icons">chevron_right</i>
            </button>
          </div>
        </div>
      </section>
    
      {/* Contact Section */}
      <section id="contact" className="section section-contact scrollspy" style={{backgroundColor: 'white', paddingTop: '3rem', paddingBottom: '3rem', marginTop: '0'}}>
        <div className="container">
          <div className="row" style={{marginBottom: 0}}>
            {/* Left Column - Photo and Socials */}
            <div className="col s12 m6" style={{paddingRight: '2rem'}}>
              <div className="contact-photo-container">
                <img src="/img/U-8989.jpg" alt="Diva Avaya Sharma" className="contact-photo responsive-img" />
              </div>
              <div className="contact-socials" style={{textAlign: 'center', marginTop: '1.5rem', marginBottom: '1rem'}}>
                <a href="https://www.linkedin.com/in/diva-sharma/" target="_blank" rel="noopener noreferrer" className="contact-social-icon">
                  <i className="fab fa-linkedin"></i>
                </a>
                <a href="https://www.instagram.com/arealdiva/" target="_blank" rel="noopener noreferrer" className="contact-social-icon">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="https://x.com/adivawhocodes/" target="_blank" rel="noopener noreferrer" className="contact-social-icon">
                  <span style={{fontWeight: 'bold', fontSize: '1.2em'}}>X</span>
                </a>
                <a href="https://medium.com/@diva.sharma" target="_blank" rel="noopener noreferrer" className="contact-social-icon">
                  <i className="fab fa-medium"></i>
                </a>
              </div>
            </div>
            
            {/* Right Column - Contact Form */}
            <div className="col s12 m6" style={{paddingLeft: '2rem'}}>
              <div className="contact-form-container">
                <h2 className="contact-form-title">Contact Diva Avaya Sharma</h2>
                <form className="contact-form" onSubmit={handleContactSubmit}>
                  <div className="contact-input-field" style={{marginBottom: '1rem'}}>
                    <label htmlFor="fullName" style={{display: 'block', marginBottom: '0.4rem', fontSize: '0.85rem', color: '#424242', fontWeight: '500'}}>
                      Name <span style={{color: '#4eaad7'}}>*</span>
                    </label>
                    <input type="text" id="fullName" className="contact-input" required placeholder="Enter your full name" />
                  </div>
                  
                  <div className="contact-input-field" style={{marginBottom: '1rem'}}>
                    <label htmlFor="email" style={{display: 'block', marginBottom: '0.4rem', fontSize: '0.85rem', color: '#424242', fontWeight: '500'}}>
                      Email <span style={{color: '#4eaad7'}}>*</span>
                    </label>
                    <input type="email" id="email" className="contact-input" required />
                  </div>
                  
                  <div className="contact-input-field" style={{marginBottom: '1rem'}}>
                    <label htmlFor="subject" style={{display: 'block', marginBottom: '0.4rem', fontSize: '0.85rem', color: '#424242', fontWeight: '500'}}>
                      Subject <span style={{color: '#4eaad7'}}>*</span>
                    </label>
                    <input type="text" id="subject" className="contact-input" required placeholder="Enter subject" />
                  </div>
                  
                  <div className="contact-input-field" style={{marginBottom: '1.5rem'}}>
                    <label htmlFor="message" style={{display: 'block', marginBottom: '0.4rem', fontSize: '0.85rem', color: '#424242', fontWeight: '500'}}>
                      Message <span style={{color: '#4eaad7'}}>*</span>
                    </label>
                    <textarea id="message" className="contact-input contact-textarea" rows="4" required></textarea>
                  </div>
                  
                  <button type="submit" className="contact-submit-btn">SUBMIT</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    
      {/* Footer */}
      <footer className="footer-section black darken-2 white-text center">
        <div className="container">
          <p className="footer-note" style={{fontSize: '1.1rem', marginBottom: '2rem'}}>
            Stay Connected
          </p>
          <div className="footer-socials">
            <a href="https://www.linkedin.com/in/diva-sharma/" target="_blank" rel="noopener noreferrer" className="footer-social-icon">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://x.com/adivawhocodes/" target="_blank" rel="noopener noreferrer" className="footer-social-icon">
              <span style={{fontWeight: 'bold', fontSize: '1.2em'}}>X</span>
            </a>
            <a href="https://www.instagram.com/arealdiva/" target="_blank" rel="noopener noreferrer" className="footer-social-icon">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://medium.com/@diva.sharma" target="_blank" rel="noopener noreferrer" className="footer-social-icon">
              <i className="fab fa-medium"></i>
            </a>
          </div>
          <p className="footer-copyright" style={{marginTop: '2rem', fontSize: '0.9rem', opacity: 0.7}}>
            Made in San Francisco
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;





